// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1_d0X","cls2":"SuggestedUserCard-cls2_Jci SuggestedUserCard-cls1_d0X"};